import '../css/createpipeline.css';
import Header from '../components/header';
import Card from '../components/card';
import React, { useState, useRef, useEffect } from "react";
import { useDrop } from "react-dnd";
import { useNavigate } from 'react-router-dom';
import { CardList } from "../Data/featureData";
import { addCardToBoard, updateDisabledCards, removeLastCardFromBoard, startPipeline, navigateToNextPage } from "../Utility/CreatePipeline/createPipelineUtils";

function CreatePipeline() {
    const [board, setBoard] = useState([]);
    const [disabledCards, setDisabledCards] = useState([]);
    const boardRef = useRef(null);
    const navigate = useNavigate();

    const [{ isOver }, drop] = useDrop(() => ({
        accept: "card",
        drop: (item) =>
            addCardToBoard(
                item.id,
                board,
                setBoard,
                (id) => updateDisabledCards(id, setDisabledCards)
            ),
        collect: (monitor) => ({
            isOver: !!monitor.isOver(),
        }),
    }));

    useEffect(() => {
        if (boardRef.current) {
            // autoscroll in fondo quando aggiungi
            boardRef.current.scrollTop = boardRef.current.scrollHeight;
            boardRef.current.scrollLeft = boardRef.current.scrollWidth;
        }
    }, [board]);

    const handleSelectCard = (id) => {
        addCardToBoard(
            id,
            board,
            setBoard,
            (addedId) => updateDisabledCards(addedId, setDisabledCards)
        );
    };

    return (
        <>
            <Header />
            <div className="bodyclassBoard">
                <div className="BoardDiv">
                    <form>
                        <div
                            className="Board"
                            ref={(dropBoard) => {
                                drop(dropBoard);
                                boardRef.current = dropBoard;
                            }}
                        >
                            {board.length === 0 ? (
                                <div className="placeholder-text textlink">
                                    {/* desktop */}
                                    <span className="ph-desktop">Drag here</span>
                                    {/* tablet+mobile */}
                                    <span className="ph-touch">Tap a tool to add it here</span>
                                </div>
                            ) : (
                                board.map((card, index) =>
                                    card && card.url ? (
                                        <div key={index} className="BoardSlot">
                                            <Card
                                                url={card.url}
                                                id={card.id}
                                                icon={card.icon}
                                                name={card.name}
                                                classtype={card.classtype}
                                                description={card.description}
                                                disableLink={true}   // non naviga dentro la Board
                                                draggable={false}    // non trascinabile nella Board
                                            />
                                        </div>
                                    ) : null
                                )
                            )}
                        </div>

                        <div className="BoardActions">
                            <button
                                type="button"
                                className="button buttonPipeline"
                                onClick={() =>
                                    removeLastCardFromBoard(board, setBoard, setDisabledCards)
                                }
                            >
                                Remove Feature
                            </button>

                            <button
                                type="button"
                                className="button buttonPipeline"
                                onClick={() =>
                                    startPipeline(
                                        board,
                                        (index, params) =>
                                            navigateToNextPage(index, params, board, navigate)
                                    )
                                }
                            >
                                Start Pipeline
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <div className="Card bodyclass bodyclassBelowBoard">
                <div className="rigaPipeline">
                    <h3 className="titolo titoloCreatePipeline">CREATE YOUR PIPELINE</h3>
                    <span className="text DescriptionCreatePipeline">
                        Pipeline allows seamless integration of multiple tools in sequence, automating workflows and accelerating complex computational processes for enhanced efficiency.
                    </span>
                    <div className="space"></div>
                </div>

                <div className="rigaPipeline">
                    {CardList.map((card) => (
                        <div
                            className={`colonna colonnaCreatePipeline ${disabledCards.includes(card.id) ? 'disabled' : ''}`}
                            key={card.id}
                        >
                            <Card
                                url={card.url}
                                id={card.id}
                                icon={card.icon}
                                name={card.name}
                                description={card.description}
                                isDisabled={disabledCards.includes(card.id)}
                                disableLink={true}                         // niente link: click = aggiungi
                                onSelect={handleSelectCard}                 // click aggiunge alla Board
                                draggable={!disabledCards.includes(card.id)}// drag solo se non disabilitata
                            />
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

export default CreatePipeline;
